"use strict";

var _regeneratorRuntime = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBrowserLanguage = void 0;

var node_polyglot_1 = __importDefault(require("node-polyglot"));

var request_1 = __importDefault(require("../request"));

var Language = __importStar(require("../language"));

var Credentials = __importStar(require("../credentials"));

var CMS = __importStar(require("../cms"));

var getLanguage = function getLanguage(str) {
  if (str.length > 2) return str.substring(0, 2);else return str;
};

exports.getBrowserLanguage = function () {
  var nav = window.navigator;
  var browserLanguagePropertyKeys = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'];

  if (Array.isArray(nav.languages)) {
    for (var i = 0; i < nav.languages.length; i++) {
      var l = nav.languages[i];

      if (l) {
        return getLanguage(l);
      }
    }
  }

  for (var _i = 0; _i < browserLanguagePropertyKeys.length; _i++) {
    var language = nav[browserLanguagePropertyKeys[_i]];

    if (language) {
      return getLanguage(language);
    }
  }

  return null;
};

var I18n = /*#__PURE__*/function () {
  function I18n(withBackend, urlFetch) {
    _classCallCheck(this, I18n);

    this.wasInit = false;
    this.lang = this.getLang();
    this.urlFetch = urlFetch ? urlFetch : this.getUrlFetch();
    this.withBackend = withBackend;
    this.init();
  }

  _createClass(I18n, [{
    key: "init",
    value: function init() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.withBackend) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", request_1.default.get(this.getUrlFetch()).then(function (res) {
                  var polyglot = new node_polyglot_1.default({
                    phrases: res
                  });
                  _this.translator = polyglot.t.bind(polyglot);
                  _this.wasInit = true;
                }));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "setLanguage",
    value: function setLanguage(language) {
      this.lang = language;
    }
  }, {
    key: "translate",
    value: function translate(key, replaceVars) {
      if (!this.translator) {
        return key;
      }

      var content = this.translator(key);
      return CMS.substituteVars(content, replaceVars, '%{');
    }
  }, {
    key: "getUrlFetch",
    value: function getUrlFetch() {
      if (process.env.I18N_URL_FETCH) {
        return process.env.I18N_URL_FETCH.replace('${locale}', this.lang);
      }

      return "/product/i18n/serve".concat(this.queryString());
    }
  }, {
    key: "getLang",
    value: function getLang() {
      try {
        return Credentials.getLanguage();
      } catch (err) {
        return Language.languageDefault;
      }
    }
  }, {
    key: "queryString",
    value: function queryString(lang) {
      return "?locale=".concat(lang ? lang : this.lang);
    }
  }]);

  return I18n;
}();

exports.default = I18n;